import React from 'react';
import ReactSelect, { components } from 'react-select';
import '../../shared/ReactSelectDarkMode.css';

export { components };

/** Shared static select with the project's consistent CSS hooks and dark-mode support. */
export default function AppSelect({ className = 'react-select-container', classNamePrefix = 'react-select', ...props }) {
  return <ReactSelect className={className} classNamePrefix={classNamePrefix} {...props} />;
}
